export enum StorageKeys {
  RETURN_TO_CKO = 'finn_return_to_checkout',
  SESSION_DATA = 'finn_session_data',
  LAST_CHECKOUT_STEP = 'finn_last_checkout_step',
  DELAY_MANAGEMENT = 'finn_delay',
}
// localStorage.setItem with expiry support and ssr safe
export const setLocalstorageValue = (
  key: StorageKeys,
  value: string | number | null | Object,
  expiryHours: number = 24
) => {
  if (typeof window === 'undefined') return;
  if (value === null) {
    localStorage.removeItem(key);

    return;
  }
  const now = new Date();
  const item = {
    value,
    expiry: expiryHours
      ? now.getTime() + expiryHours * 60 * 60 * 1000
      : undefined,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

// localStorage.getTime with expiry support and ssr safe
export const getLocalstorageValue = (key: StorageKeys) => {
  if (typeof window === 'undefined') return null;
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (item.expiry && now.getTime() > item.expiry) {
    localStorage.removeItem(key);

    return null;
  }

  return item.value;
};
